import { atom, useAtom } from 'jotai';

import { accountsAtom } from '../../stores/accounts.atom';
import { campaignAtom } from '../../stores/campaign.atom';
import getOrdersYear, { ordersYearAtom } from '../../stores/orders-year.atom';
import { organisationAtom } from '../../stores/organisation.atom';
import getAccounts from '../../utils/get-accounts';
import getCampaign from '../../utils/get-campaign';
import getOrganisation from '../../utils/get-organisation';

export type Globals = {
  campaign: number;
  accounts: number[];
  organisation: number[];
  ordersYear: number;
};

export type QueriesFactory<T> = (globals: Globals) => T;

// Function overloads
export function useQueriesWithGlobal<T>(queriesFactory: QueriesFactory<T>): T;
export function useQueriesWithGlobal<T>(
  queriesFactory: QueriesFactory<T>[],
): T[];

export function useQueriesWithGlobal<T>(
  queriesFactory: QueriesFactory<T> | QueriesFactory<T>[],
): T | T[] {
  const [campaign] = useAtom(campaignAtom);
  const [accounts] = useAtom(accountsAtom);
  const [organisation] = useAtom(organisationAtom);
  const [ordersYear] = useAtom(ordersYearAtom);

  const globals: Globals = {
    campaign: campaign!,
    accounts: accounts,
    organisation: organisation,
    ordersYear: ordersYear!,
  };

  if (Array.isArray(queriesFactory)) {
    return queriesFactory.map((factory) => factory(globals));
  } else {
    return queriesFactory(globals);
  }
}

export function getQueriesWithGlobal<T>(queriesFactory: QueriesFactory<T>): T {
  const campaign = getCampaign();
  const accounts = getAccounts();
  const organisation = getOrganisation();
  const ordersYear = getOrdersYear();

  const globals: Globals = {
    campaign: campaign!,
    accounts: accounts,
    organisation: organisation,
    ordersYear: ordersYear!,
  };

  return queriesFactory(globals);
}
